var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.column.customFunction)?_c('span',{class:_vm.pClass},[_vm._v("\n    "+_vm._s(_vm.column.customFunction(_vm.data))+"\n")]):_c('span',{class:_vm.pClass},[_vm._v("\n    "+_vm._s(_vm.data[_vm.column.field])+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }